import React, { CSSProperties, useState } from 'react'
import { useQuery } from '@apollo/client'
import { Drawer, DrawerProps } from 'antd'
import { useHistory, useLocation } from 'react-router-dom'
import DemandeContentEditor from './DemandeContentEditor'
import DemandeContent from './DemandeContent'
import { COLOR } from '../../constants'
import { useCustomParams, useSmallScreen } from '../../lib/hooks'
import { D4_Fn_View_Demande } from '../../types'
import { EVENEMENTS } from '../../apollo/query/demande.query'
import styled from 'styled-components'
import DemandeHeader from './DemandeHeader'
import FileList from './FileList'
import DemandeProcedure from './DemandeProcedure'

const StyledDrawer: React.FC<DrawerProps> = styled(Drawer)`
  isolation: isolate;
  .ant-drawer-close {
    position: absolute;
    right: 0px;
    top: 20px;
    z-index: 1;
    /* right: 10px; */
  }
  .ant-typography.ant-typography-ellipsis {
    margin-bottom: 0;
  }
`
const bodyStyle: CSSProperties = {
  backgroundColor: COLOR.lightestGrey,
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column-reverse',
  marginTop: '40px',
}

const DemandeDrawer = () => {
  const history = useHistory()
  const demandeId = useCustomParams().get('demandeId')
  const { data, loading } = useQuery<{ demande: D4_Fn_View_Demande[] }, { id: number }>(EVENEMENTS, {
    variables: { id: Number(demandeId) },
    fetchPolicy: 'cache-and-network',
    skip: !demandeId,
  })

  const [openFilesDrawer, setOpenFilesDrawer] = useState(false)
  const [openProcedure, setOpenProcedure] = useState(false)

  const smallScreen = useSmallScreen()
  const { pathname } = useLocation()

  const demande = data?.demande?.[0]

  if (!demande) return null

  return (
    <StyledDrawer
      bodyStyle={bodyStyle}
      visible={!!demandeId}
      width={smallScreen ? '100%' : '60%'}
      mask={false}
      onClose={() => history.push(pathname)}
      footer={
        <DemandeContentEditor
          demandeId={Number(demandeId)}
          onOpenFilesDrawer={() => setOpenFilesDrawer(true)}
          onOpenProcedure={() => setOpenProcedure(true)}
          procedure={demande.kanbantitre === 'Procédures'}
        />
      }
      closable
    >
      {demande.kanbantitre === 'Procédures' && (
        <Drawer
          title="Procédure"
          width={smallScreen ? '100%' : 840}
          closable={false}
          onClose={() => setOpenProcedure(false)}
          visible={openProcedure}
        >
          <DemandeProcedure demandeId={Number(demandeId)} />
        </Drawer>
      )}

      <Drawer
        title="Fichiers"
        width={320}
        closable={false}
        onClose={() => setOpenFilesDrawer(false)}
        visible={openFilesDrawer}
      >
        <FileList evenements={demande?.evenements} />
      </Drawer>

      <DemandeContent loading={loading && !demande} demande={demande} />
      <DemandeHeader demande={demande} />
    </StyledDrawer>
  )
}

export default DemandeDrawer
